import { action } from 'mobx'

import ListStore from '../../../shared-lib/stores/ListStore'
import ExternalReviewModel, { $ExternalReviewModel } from './ExternalReviewModel'

export default class ExternalReviewStore extends ListStore<$ExternalReviewModel> {
  fetchMethodName = 'externalReviews'
  ModelClass = ExternalReviewModel

  @action.bound async updateReviewVisible_api(_id: string, visible: boolean) {
    const { requester } = this.rootStore.communication

    this.loading = true
    try {
      const { updateExternalReviewVisible } = await requester.updateExternalReviewVisible({ _id, visible })
      this.mergeData([updateExternalReviewVisible])
    } finally {
      this.loading = false
    }
  }

  @action.bound async createReview_api(data: ExternalReviewInput) {
    const { requester } = this.rootStore.communication

    this.loading = true
    try {
      await requester.createExternalReview({ data })
    } finally {
      this.loading = false
    }
  }

  @action.bound async createSecretSpaExternalReview_api(data: SecretSpaExternalReviewInput) {
    const { requester } = this.rootStore.communication

    this.loading = true
    try {
      await requester.createSecretSpaExternalReview({ data })
    } finally {
      this.loading = false
    }
  }

  async fetchExternalProfessionalReviews_api() {
    return this.fetchItems_api({
      variables: {
        filter: {
          professionalId: this.rootStore.userStore.data._id,
        },
        pagination: {
          skip: this.items.length,
          limit: 10,
        },
      },
    })
  }
}

export type $ExternalReviewStore = ExternalReviewStore
